import * as React from 'react';
import styled from 'styled-components';
import { Switch as MaterialSwitch, FormControlLabel } from '@mui/material';

const StyledSwitch = styled(MaterialSwitch)`
    & .MuiSwitch-colorSecondary.Mui-checked {
        color: blue;
    }

    & .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
        background-color: gray;
    }
`;

export type SwitchProps = {
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

type Props = SwitchProps & {
    className?: string;
}

export const Switch: React.FC<Props> = ({
    label,
    checked,
    onChange,
    className,
}) => {
    const handleOnChange = (event) => {
        onChange(event.target.checked);
    };

    return (
        <FormControlLabel
            className={className}
            labelPlacement="start"
            label={label}
            control={
                <StyledSwitch
                    checked={checked}
                    onChange={handleOnChange} />
            } />
    );
};
